if($('.type-detail #simple-variants').length){
    $('#simple-variants select').each(function(){
        simple_variant = '<div class="select-variant">'
            $(this).find('option').each(function(index){
                var optionText = $(this).text()
                var optionValue = $(this).attr('value')
                var optionIndex = index
                if ($.isNumeric(optionValue)) {
                    var parts = optionText.split(",");
                    var details = {};
                    parts.forEach(function(part) {
                        var keyValueMatch = part.trim().match(/^(.*?):\s*(.*?)$/);
                        var specialMatch = part.trim().match(/(\d+)\s*-\s*Skladom\s*>\s*(\d+)\s*pár\s*\(([\d\s]+Kč)\)$/);
                        if (keyValueMatch) {
                            var key = keyValueMatch[1].trim();
                            var value = keyValueMatch[2].trim().split('-')[0].trim();
                            details[key] = value;
                        }
                    });
                    if($('.p-final-price-wrapper .price-final-holder.'+optionIndex).length){
                        var optionPrice = $('.p-final-price-wrapper .price-final-holder.'+optionIndex).text().trim();
                    }
                    else{
                        var optionPrice = $('.p-final-price-wrapper .price-final-holder').text().trim();
                    }
                    if($('.p-data-wrapper .detail-parameters tr .availability-label').closest('.choose-variant.'+optionIndex).length){
                        var optionStock = $('.p-data-wrapper .detail-parameters tr .availability-label').closest('.choose-variant.'+optionIndex).text().replace(/\s+/g, ' ').trim();
                    }
                    else{
                        var optionStock = $('.p-data-wrapper .detail-parameters tr .availability-label').closest('td').text().replace(/\s+/g, ' ').trim();
                    }
                    
                    if($('.p-data-wrapper .detail-parameters tr.p-code .choose-variant.'+optionIndex).length){
                        var optionCode = $('.p-data-wrapper .detail-parameters tr.p-code .choose-variant.'+optionIndex).text().replace(/\s+/g, ' ').trim();
                    }
                    else{
                        var optionCode = $('.p-data-wrapper .detail-parameters tr.p-code td').text().replace(/\s+/g, ' ').trim();
                    }
                    
                
                    var regex = /-|>/;
                        if (regex.test(optionStock)) {
                            var getNewQuantiti = optionStock//.replace(/\s+/g, " ").trim().replace(/\(/g, "-").replace(/^(.+?)\s+(\d+.*)$/, "$1 - $2").split(/[>-]/)[1]
                            var regex = /\d+/; // Regulární výraz pro nalezení jedné nebo více číslic
                            var match = getNewQuantiti.match(regex); // Použití regulárního výrazu pro hledání čísel v řetězci
                            if (match) {
                                var number = parseInt(match[0], 10); // Převod nalezeného řetězce na číslo
                                console.log(number); // Výpis čísla do konzole
                            }
                            else{
                                var number = '0'
                            }
                            details["ocisteny-pocet"] = number

                        }
                        else{
                            var getNewQuantiti = optionStock
                            
                            var regex = /\d+/; // Regulární výraz pro nalezení jedné nebo více číslic
                            var match = getNewQuantiti.match(regex); // Použití regulárního výrazu pro hledání čísel v řetězci
                            console.log(match)
                            if (match) {
                                var number = parseInt(match[0], 10); // Převod nalezeného řetězce na číslo
                                console.log(number); // Výpis čísla do konzole
                            }
                            else{
                                var number = '0'
                            }

                            details["ocisteny-pocet"] = number
                        }
                  //  var getNewQuantiti = optionStock.replace(/\s+/g, " ").trim().replace(/\(/g, "-").replace(/^(.+?)\s+(\d+.*)$/, "$1 - $2").split(/[>-]/)[1]
                    var getCustomOptionStockAvailability = optionStock.replace(/\s+/g, " ").trim().replace(/^(.+?)\s+(\d+.*)$/, "$1 - $2").split(/[>-]/)[0].replace('(', '').trim();
                    var getCustomOptionStockQuantity = optionStock.replace(/\s+/g, " ").trim().replace(/^(.+?)\s+(\d+.*)$/, "$1 - $2").split(/[>-]/)[1];

                    /*var processed = optionStock.replace(/\s+/g, " ") // Nahradí všechny sekvenční bílé znaky jednou mezerou
                      .trim() // Odstraní bílé znaky na začátku a na konci řetězce
                      .replace(/^(.+?)\s+(\d+.*)$/, "$1 - $2") // Formátuje řetězec na "text - číslo"
                      .split(/[\s>-]/)[1].replace(')', '').replace('(', ''); // Rozdělí řetězec podle mezery, '>' nebo '-' a vybere druhý segment
*/
                  

                   // console.log(getCustomOptionStockQuantity)
                    details["Cena"] = optionPrice.replace(/[^\d,.-]/g, '').replace(',', '.');
                   //if($('.admin-logged').length){
                    var match = getCustomOptionStockAvailability.match(/Skladom/);
                    if (match) {
                        // Pokud obsahuje "Skladom" a číslo, vypište nebo využijte číslo
                       
                        // Zde můžete provést další akce s extrahovaným číslem
                        details["Dostupnost"] = match[0];
                    }
                    else{
                        details["Dostupnost"] = getCustomOptionStockAvailability.trim();
                    }

                  
                   
                   
                   
                  //  details["Dostupnost"] = getCustomOptionStockAvailability.trim();
                    if(typeof getCustomOptionStockQuantity !== 'undefined'){
                     //   console.log(getCustomOptionStockQuantity)
                        details["Počet kusů"] = getCustomOptionStockQuantity.replace(/[^\d,.-]/g, '').replace(',', '.');
                       // details["Počet kusů"] = getCustomOptionStockQuantity
                    } 
                    else{
                        details["Počet kusů"] = '0'
                    }                       
                    var $div = $('<div class="box" data-value="'+optionValue+'" data-index="'+optionIndex+'" data-code="'+optionCode+'"><div class="text"></div></div>');
                   
                    $.each(details, function(key, value) {
                        if (value !== undefined && value !== null) {
                            var normalizedKey = key.normalize('NFD').replace(/[^\w]/g, '').toLowerCase();
                            $div.attr('data-' + key.normalize('NFD').replace(/[^\w]/g, '').toLowerCase(), value);
                        }
                      //  console.log(validKeys)
                     //   console.log(normalizedKey)
                        if(validKeys[normalizedKey]) {
                            $div.find('.text').html(value);
                        }
                    });
                     simple_variant += $div.prop('outerHTML')
                }
            })
        simple_variant+= '</div>'

    })
    $('#simple-variants').after('<div class="wrap_sirka_delka" style="display:none;"><div class="barva" data-number="0">Barva: <span></span></div><div class="delka" data-number="0">Vnútorná dĺžka topánky: <span></span></div><div class="sirka" data-number="0">Vnútorná šírka topánky: <span></span></div></div>')
    $('#simple-variants').after(simple_variant)
    $('#simple-variants').hide()
}

$(document).ready(function() {
    var vseNaDotaz = true;
    if($('#simple-variants').length){
        $('.select-variant .box').each(function() {
            if ($(this).attr('data-dostupnost') !== "Na dotaz" || $(this).attr('data-ocistenypocet') !== "0") {
                vseNaDotaz = false;
                return false;
            }
        });
    }
    else{
        vseNaDotaz = false
    }
    
    if (vseNaDotaz) {
        $(document).trigger('vseNaDotaz');
    }
});
$(document).on('vseNaDotaz', function() {
    $('.p-to-cart-block .add-to-cart-button, .p-to-cart-block .add-to-cart').hide()
    $('.p-to-cart-block .watchDogCustom').removeClass('hide')
});




if($('.watchdog').length){
    $('.p-data-wrapper').append('<div class="watchdogBox hide"><p>Pre túto variantu nie je dostupná vaša veľkosť. <strong>Zvoľte prosím iný variant, alebo si nastavte <a href="'+$('a.watchdog').attr('href')+'" class="link-icon watchdog">stráženie dostupnosti</a>.</strong></p><a href="'+$('a.watchdog').attr('href')+'" class="btn btn-green link-icon watchdog">Strážiť dostupnosť</a></div>')
    $('.p-to-cart-block').append('<div class="watchDogCustom hide"><a href="'+$('a.watchdog').attr('href')+'" class="btn btn-green link-icon watchdog">Strážiť dostupnosť</a></div>')
}

$(document).on('click', '.select-variant .box', function(){
    const variantData = $(this).data('value')
    const variantParameterId = $(this).data('parameter-id')
    $("select#simple-variants-select option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
    var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
    var $splitParameters = $(selector);
    $splitParameters.trigger('change');
    $(this).closest('.select-variant').find(".box:not([data-value='"+variantData+"'])").removeClass("active");
    $(this).addClass("active");    
    $("select#simple-variants-select")[0].dispatchEvent(new Event('change'));
    $('.custom-variant-wrap .box').each(function(){
        const variantData = $(this).data('value')
        const variantParameterId = $(this).data('parameter-id')
        const unavailable = $("select#simple-variants-select option[value='" + variantData + "']").hasClass("unavailable-option")    
        if (unavailable === true) {
            $(this).addClass("unavailable").removeClass("active")
        }
        else{
            $(this).removeClass("unavailable")
        } 
    })
    $('.watchdogBox, .watchDogCustom').addClass('hide')
    $('.add-to-cart, .p-to-cart-block button[type="submit"]').removeClass('hide')
    $('.p-final-price-wrapper .price-final, .p-final-price-wrapper .availability-label').removeClass('grey')
    if($(this).attr('data-ocistenypocet') === '0'){
        $('.watchdogBox, .watchDogCustom').removeClass('hide')
        $('.add-to-cart, .p-to-cart-block button[type="submit"]').addClass('hide')
        $('.p-final-price-wrapper .price-final, .p-final-price-wrapper .availability-label').addClass('grey')
    }
    $('.stockCustom .customStockInfo').addClass('hide')
    $('.stockCustom .customStockInfo[data-code="'+$(this).attr('data-code')+'"]').removeClass('hide')
    $('.stockCustom .velikost').html($(this).attr('data-code'))
    $('.wrap_sirka_delka').show()
    $('.wrap_sirka_delka .delka').attr('data-number', $(this).data('vnutornadlzka'))
    $('.wrap_sirka_delka .delka span').html($(this).data('vnutornadlzka'))
    $('.wrap_sirka_delka .sirka').attr('data-number', $(this).data('vnutornasirka'))
    $('.wrap_sirka_delka .sirka span').html($(this).data('vnutornasirka'))
    $('.wrap_sirka_delka .barva').attr('data-number', $(this).data('barva'))
    $('.wrap_sirka_delka .barva span').html($(this).data('barva'))

})

$(document).ready(function(){
    $(".select-variant").each(function() {
        var $variants = $(this).find("div.box");
        if ($variants.length === 1) {
          $variants.addClass("active");
        }
      });
    var urlParams = new URLSearchParams(window.location.search);
    var parameterValueId = urlParams.get("parameterValueId");
    var $divToHighlight = $("div.box[data-value='" + parameterValueId + "']");
    if ($divToHighlight.length > 0) {
        $divToHighlight.addClass("active");
    }
})

$(document).ready(function(){
if($('.products-alternative-wrapper').length){
    url = window.location.href; 
    image = $('.p-image-wrapper .p-image a img').attr('src').replace('/big/', '/detail/');
    if($('#simple-variants').length){
        var maxPocetKusu = 0; // Proměnná pro uchování nejvyšší hodnoty
        $('.select-variant .box').each(function() {
            let pocetKusu = parseInt($(this).attr('data-pocetkusu'), 10); // Převede hodnotu na číslo
            if (pocetKusu > maxPocetKusu) {
                maxPocetKusu = pocetKusu; // Aktualizuje nejvyšší hodnotu, pokud je aktuální hodnota vyšší
            }
        });
    }
    else{
        if(parseFloat($('.detail-parameters .availability-amount').text())>0){
            maxPocetKusu = 1
        }
       
    }
   
   // console.log(maxPocetKusu)
    if(maxPocetKusu>0){
        var dataStock = 'skladom'
    }
    else{
        var dataStock = 'nadotaz'
    }
    $('<div class="color-var"><div class="product first" data-stock="'+dataStock+'">'+
    '<div class="p">'+
        '<a href="'+url+'" class="image">'+
            '<img src="'+image+'">'+
        '</a>'+
    '</div>'+
'</div></div>').insertBefore('.p-to-cart-block')

$('.products-alternative.products-additional .products-block .product').clone().appendTo('.color-var')

$('.color-var .product').each(function(){
    $(this).attr('value', $(this).find('span[data-micro="sku"]').text().replace(/\./g, '').replace(/-/g, '').split('/')[0]).attr('data-value', $(this).find('span[data-micro="sku"]').text().replace(/\./g, '').replace(/-/g, '').split('/')[0])
}) 
    var found = {};
    $('.color-var .product').each(function(){
      var $this = $(this);
      if(found[$this.attr('value')]){
        $this.remove();
      }else{
        found[$this.attr('value')] = true;
      }
    });
}
});